




















































import ProjecTaskTypeApi from "@/api/project/project-task-type-api";
import SelectTaskType from "@/components/project/SelectTaskType.vue";
import SelectFavorite from "@/components/project/SelectFavorite.vue";
import TaskType from "@/entities/task-type";
import { client } from "@/api/request";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import { ListCompanyUser, getCompanyEndUser } from "@/api/company-api";

const taskTypeApi = new ProjecTaskTypeApi(client);
interface CompanyOption {
  value: number | string;
  text: string;
}

export interface Param {
  projectId: number;
  taskTypeIds?: number[];
  vendorId?: number;
  favorite?: string;
}
@Component({
  components: {
    SelectTaskType,
    SelectFavorite
  }
})
export default class PurchaseVendorModal extends Vue {
  @Prop({ default: () => ({ vendorId: -1, vendorName: "" }) })
  readonly vendor!: { vendorId: number; vendorName: string };
  localVendorId: number | null = null;

  taskTypes: TaskType[] = [];
  data: ListCompanyUser[] = [];
  companies: CompanyOption[] = [];
  query: Param = {
    projectId: this.projectId,
    taskTypeIds: [],
    vendorId: -1,
    favorite: ""
  };

  fields = [
    { key: "vendorId", label: "選択" },
    { key: "vendorName", label: "会社名" },
    { key: "taskTypeNames", label: "業種" }
  ];
  fieldsCompany = [{ value: -1, text: "全ての会社" }];

  async created() {
    await this.getData();
    await this.loadTaskTypes();
    await this.getCompany();
  }

  private async loadTaskTypes() {
    this.taskTypes = await taskTypeApi.getProjectStaffTaskType(this.projectId);
  }

  private async getCompany() {
    const originalCompanies = await getCompanyEndUser({
      projectId: this.projectId
    });
    this.companies = this.fieldsCompany.concat(
      originalCompanies.map((company: ListCompanyUser) => ({
        value: company.vendorId as number,
        text: company.vendorName
      }))
    );
  }

  private async getData() {
    const cloneQuery = cloneDeep(this.query);
    cloneQuery.taskTypeIds =
      cloneQuery.taskTypeIds &&
      cloneQuery.taskTypeIds.map((item: any) => item.id);
    this.data = await getCompanyEndUser(cloneQuery);
  }

  get projectId(): number {
    return this.$store.state.project.projectId;
  }

  @Watch("query", { deep: true })
  onChangeQuery() {
    this.getData();
  }

  @Watch("vendor", { immediate: true, deep: true })
  onVendorChange(newVendor: { vendorId: number }) {
    this.localVendorId = newVendor.vendorId !== -1 ? newVendor.vendorId : null;
  }

  handleFavoriteChange(value: string) {
    this.query.favorite = value;
  }

  showModal() {
    this.localVendorId = this.vendor ? this.vendor.vendorId : null;
    (this.$refs.vendorModal as any).show();
  }

  hide() {
    (this.$refs.vendorModal as any).hide();
  }

  handleSave() {
    (this.$refs.btnSubmit as any).click();
  }

  handleSubmit() {
    const selectedItem = this.data.find(
      item => item.vendorId === this.localVendorId
    );
    if (!selectedItem) {
      alert("発注先を必ず選択してください。");
      return;
    }

    this.$emit("selectedVendor", selectedItem);
    this.hide();
  }
}
